import { getKey } from '../../core'

const MASK_CLASS = getKey('mask-'),
  LOAD_CLASS = getKey('load-'),
  REMOTE_LOAD_CLASS = getKey('remote-'),
  layer = 'z-index:2000',
  k1 = 'justify-content',
  k2 = 'position',
  k3 = `;${k2}:fixed`

const style = document.createElement('style')
style.type = 'text/css'
style.textContent = [
  '.b-fx{display:flex;align-items:center}',
  `.b-j-c{${k1}:center}`,
  `.b-j-sb{${k1}:space-between}`,
  '.b-fx-col{flex-direction:column}',
  `.b-rel{${k2}:relative}`,
  `.b-abs{${k2}: absolute}`,
  '.b-ellipsis{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}',
  `.${MASK_CLASS}{inset:top:0;left:0px;right:0px,bottom:0px;background-color:#ffffff40;${layer}}`,
  `.${LOAD_CLASS}>div{${layer}${k3}}`,
  `.${REMOTE_LOAD_CLASS}{width:100%;height:100%}`
].join('')
document.head.insertBefore(style, document.head.childNodes[0])

export {
  k3,
  MASK_CLASS,
  LOAD_CLASS,
  REMOTE_LOAD_CLASS
}